"use client"

import { createContext, useContext, useState, useEffect } from "react"
import { apiRequest, endpoints } from "../utils/api"

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem("adminToken")
    if (token) {
      verifyToken(token)
    } else {
      setLoading(false)
    }
  }, [])

  const verifyToken = async (token) => {
    try {
      await apiRequest("/api/admin/analytics", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setUser({ role: "admin" }) // If request works, set admin user
    } catch (error) {
      // Token is invalid, remove it
      localStorage.removeItem("adminToken")
    } finally {
      setLoading(false)
    }
  }

  const login = async (username, password) => {
    try {
      const { token, user } = await apiRequest(endpoints.adminLogin, {
        method: "POST",
        body: JSON.stringify({
          username,
          password,
        }),
      })

      // Store token
      localStorage.setItem("adminToken", token)

      // Set user
      setUser(user)

      return { success: true }
    } catch (error) {
      return {
        success: false,
        error: error.message || "Login failed",
      }
    }
  }

  const logout = () => {
    localStorage.removeItem("adminToken")
    setUser(null)
  }

  const value = {
    user,
    login,
    logout,
    loading,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
